<template>
  <div class="flex space-x-4 items-center">
    <base-dropdown-2
      v-if="
        !this.$store.getters['auth/isStaff'] && $store.getters['auth/companyProfiles'].length > 0
      "
      context="secondary"
      class="relative"
      trigger="click"
    >
      <base-icon icon="company" class="text-xl sm:mr-2 text-primary font-medium" />
      <span class="hidden sm:block text-sm">{{
        $store.getters['auth/companyProfiles'].filter(c => c.id === userProfile)[0].name
      }}</span>

      <template #body>
        <div class="py-1 w-36">
          {{ profile }}
          <div
            :class="[
              profile.id === userProfile ? 'selected' : '',
              'comp-profile px-4 py-2 cursor-pointer leading-5',
            ]"
            v-for="profile in $store.getters['auth/companyProfiles']"
            :key="profile.id"
            @click="selectProfile(profile.id)"
          >
            {{ profile.name }}
          </div>
        </div>
      </template>
    </base-dropdown-2>
    <base-dropdown-2 placement="bottom" :title="true" context="secondary">
      <template #title>
        <div class="flex items-center py-3 w-52">
          <div class="">
            <span
              v-if="currentUser.name !== ''"
              class="text-sm leading-5 font-medium text-secondary-dark"
            >
              {{ currentUser.name }}
            </span>
            <div class="text-sm leading-5 text-dark-gray">
              {{ currentUser.email }}
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="py-1">
          <base-link
            name="Profile"
            class="block px-4 py-2 no-underline text-sm leading-5 text-dark-gray hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >
            <span class="truncate">{{ $t(`mygwf.components.User.MainHeaderMenu.profile`) }}</span>
          </base-link>
          <base-link
            name="Logout"
            class="block px-4 py-2 no-underline text-sm leading-5 text-red-default hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
          >
            <span class="truncate">{{ $t(`mygwf.components.User.MainHeaderMenu.sign_out`) }}</span>
          </base-link>
        </div>
      </template>
      <base-icon icon="user-solid-square" class="text-xl text-primary" />
    </base-dropdown-2>
    <div class="relative inline-block">
      <div class="">
        <SelectLocale isDropdown />
      </div>
      <!-- <div>
        <button
          type="button"
          class="inline-flex justify-center w-full border px-2 py-2 bg-secondary text-sm leading-5 font-medium text-primary hover:bg-white focus:outline-none focus:ring-2 active:text-gray-800 transition ease-in-out duration-150"
          id="notifications-menu"
          aria-haspopup="true"
          aria-expanded="true"
          @click="isOpen = !isOpen"
          v-tooltip="{trigger: 'manual', show: isOpen, content: `No new notifications`}"
        >
          <base-icon icon="notification" class="text-xl" />
          <span v-if="hasNotification" class="flex h-3 w-3 absolute top-0 right-0">
            <span
              class="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-pink-400 opacity-75"
            ></span>
            <span class="relative inline-flex rounded-full h-3 w-3 bg-pink-500"></span>
          </span>
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
import {BaseIcon, BaseLink, BaseDropdown2} from '@/components/base'
import SelectLocale from '@/components/shared/SelectLocale.vue'

export default {
  components: {
    BaseIcon,
    BaseLink,
    BaseDropdown2,
    SelectLocale,
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser']
    },
    hasNotification() {
      return this.$store.getters['app/hasNotification']
    },
    userProfile() {
      return this.$store.getters['auth/activeCompany']
    },
  },
  data() {
    return {
      isVisibleUserSubNav: false,
      isVisibleCompanySubNav: false,
      isOpen: false,
    }
  },
  methods: {
    async selectProfile(id) {
      if (this.userProfile === id) return
      this.$store.dispatch('auth/getProfileForUser', id)
      await this.$store.dispatch('auth/changeDefaultCompany', id)
    },
    blurUserSelect() {
      this.isVisibleUserSubNav = false
    },
    blurCompanySelect() {
      this.isVisibleCompanySubNav = false
    },
    close() {
      this.isOpen = false
    },
  },
  directives: {
    // ClickOutside,
  },
}
</script>

<style>
.comp-profile:hover,
.comp-profile.selected {
  background-color: rgb(247, 250, 252);
}
</style>
